(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[931],{

/***/ 29387:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t={year:0,month:1,day:2,hour:3,minute:4,second:5},e={};return function(n,i,o){var r,a=function(t,n,i){void 0===i&&(i={});var o=new Date(t),r=function(t,n){void 0===n&&(n={});var i=n.timeZoneName||"short",o=t+"|"+i,r=e[o];return r||(r=new Intl.DateTimeFormat("en-US",{hour12:!1,timeZone:t,year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit",second:"2-digit",timeZoneName:i}),e[o]=r),r}(n,i);return r.formatToParts(o)},u=function(e,n){for(var i=a(e,n),r=[],u=0;u<i.length;u+=1){var f=i[u],s=f.type,m=f.value,c=t[s];c>=0&&(r[c]=parseInt(m,10))}var d=r[3],l=24===d?0:d,h=r[0]+"-"+r[1]+"-"+r[2]+" "+l+":"+r[4]+":"+r[5]+":000",v=+e;return(o.utc(h).valueOf()-(v-=v%1e3))/6e4},f=i.prototype;f.tz=function(t,e){void 0===t&&(t=r);var n=this.utcOffset(),i=this.toDate(),a=i.toLocaleString("en-US",{timeZone:t}),u=Math.round((i-new Date(a))/1e3/60),f=o(a,{locale:this.$L}).$set("millisecond",this.$ms).utcOffset(15*-Math.round(i.getTimezoneOffset()/15)-u,!0);if(e){var s=f.utcOffset();f=f.add(n-s,"minute")}return f.$x.$timezone=t,f},f.offsetName=function(t){var e=this.$x.$timezone||o.tz.guess(),n=a(this.valueOf(),e,{timeZoneName:t}).find((function(t){return"timezonename"===t.type.toLowerCase()}));return n&&n.value};var s=f.startOf;f.startOf=function(t,e){if(!this.$x||!this.$x.$timezone)return s.call(this,t,e);var n=o(this.format("YYYY-MM-DD HH:mm:ss:SSS"),{locale:this.$L});return s.call(n,t,e).tz(this.$x.$timezone,!0)},o.tz=function(t,e,n){var i=n&&e,a=n||e||r,f=u(+o(),a);if("string"!=typeof t)return o(t).tz(a);var s=function(t,e,n){var i=t-60*e*1e3,o=u(i,n);if(e===o)return[i,e];var r=u(i-=60*(o-e)*1e3,n);return o===r?[i,o]:[t-60*Math.min(o,r)*1e3,Math.max(o,r)]}(o.utc(t,i).valueOf(),f,a),m=s[0],c=s[1],d=o(m).utcOffset(c);return d.$x.$timezone=a,d},o.tz.guess=function(){return Intl.DateTimeFormat().resolvedOptions().timeZone},o.tz.setDefault=function(t){r=t}}}));

/***/ }),

/***/ 39504:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/why-lease",
      function () {
        return __webpack_require__(78525);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 48861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* reexport safe */ _VehicleCard__WEBPACK_IMPORTED_MODULE_0__.U; }
/* harmony export */ });
/* harmony import */ var _VehicleCard__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63052);



/***/ }),

/***/ 65299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* reexport */ ChatWidget; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./lib/utilities/system.js + 1 modules
var system = __webpack_require__(70591);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./components/styleguide/ChatWidget/ChatWidget.tsx



var ChatWidget = function() {
    if (!(0,system/* isProd */.BB)() || !"0e82ae7a-23e7-4571-a768-93f6cea963b2") {
        return false;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        id: "ze-snippet",
        strategy: "lazyOnload",
        src: "https://static.zdassets.com/ekr/snippet.js?key=".concat("0e82ae7a-23e7-4571-a768-93f6cea963b2")
    });
};

;// CONCATENATED MODULE: ./components/styleguide/ChatWidget/index.ts



/***/ }),

/***/ 27838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* reexport */ LocoScore; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/styleguide/LocoScore/loco-score.module.scss
var loco_score_module = __webpack_require__(53644);
var loco_score_module_default = /*#__PURE__*/__webpack_require__.n(loco_score_module);
;// CONCATENATED MODULE: ./components/styleguide/LocoScore/LocoScore.tsx



var LocoScore = function(param) {
    var rating = param.rating, _className = param.className, className = _className === void 0 ? "" : _className, _iconOnly = param.iconOnly, iconOnly = _iconOnly === void 0 ? false : _iconOnly, _isInline = param.isInline, isInline = _isInline === void 0 ? false : _isInline;
    var ref = (0,react.useState)("0, 100"), strokeDasharray = ref[0], setStrokeDasharray = ref[1];
    var ref1 = (0,react.useState)("#FFCC00"), colour = ref1[0], setColour = ref1[1];
    var ref2 = (0,react.useState)(0), currentRating = ref2[0], setCurrentRating = ref2[1];
    var PERFECT_SCORE = 73;
    (0,react.useEffect)(function() {
        // Setting up the dynamic keyframe end value when the component mounts or `rating` changes
        if (currentRating !== rating) {
            var animationCSS = "".concat(rating / 100 * PERFECT_SCORE, ", 100");
            var animation = setTimeout(function() {
                setStrokeDasharray(animationCSS);
                setColour(rating >= 80 ? "#FF2D55" : rating > 70 ? "#F15A24" : "#FFCC00");
                setCurrentRating(rating);
            }, 5);
            return function() {
                clearTimeout(animation);
            };
        }
    }, [
        currentRating,
        rating
    ]);
    var getDescriptionFromRating = function() {
        if (rating >= 90) {
            return "Amazing value";
        } else if (rating >= 80) {
            return "Great value";
        } else if (rating >= 70) {
            return "Fair value";
        } else {
            return "Low value";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((loco_score_module_default()).container, " ").concat(className),
        "data-is-inline": isInline,
        "data-icon-only": iconOnly,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                style: {
                    position: "relative",
                    display: "grid",
                    placeItems: "center",
                    height: 34,
                    width: 34
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        width: "34",
                        height: "30",
                        viewBox: "0 0 34 30",
                        fill: "none",
                        className: (loco_score_module_default()).ring,
                        style: {
                            position: "absolute",
                            inset: 0,
                            zIndex: 4
                        },
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M6.5 28C3.60451 25.1157 1.5 21.5 1.5 17C1.5 9 8.78728 1.5 17 1.5C25.2127 1.5 32.2701 8.94483 32.4028 17.3729C32.3374 21.3134 30.7773 24.992 27.5 28",
                            stroke: colour,
                            style: {
                                strokeDasharray: strokeDasharray
                            },
                            strokeLinecap: "round",
                            strokeWidth: "3"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        width: "34",
                        height: "30",
                        viewBox: "0 0 34 30",
                        fill: "none",
                        style: {
                            position: "absolute",
                            inset: 0,
                            zIndex: 0
                        },
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M6.5 28C3.60451 25.1157 1.5 21.5 1.5 17C1.5 9 8.78728 1.5 17 1.5C25.2127 1.5 32.2701 8.94483 32.4028 17.3729C32.3374 21.3134 30.7773 24.992 27.5 28",
                            stroke: "#E5E5EA",
                            strokeLinecap: "round",
                            strokeWidth: "3"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (loco_score_module_default()).score,
                        style: {
                            color: colour
                        },
                        children: rating
                    }),
                    rating > 90 && /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        width: "14",
                        height: "13",
                        viewBox: "0 0 14 13",
                        fill: "none",
                        className: (loco_score_module_default()).flame,
                        style: {
                            position: "absolute",
                            bottom: 0
                        },
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M5.19652 8.10588C5.53809 8.10588 5.86567 7.9702 6.10719 7.72867C6.34872 7.48715 6.4844 7.15957 6.4844 6.818C6.4844 6.1071 6.22683 5.7877 5.96925 5.27255C5.41701 4.16858 5.85386 3.18413 6.99955 2.18164C7.25713 3.46952 8.02986 4.70588 9.06016 5.53013C10.0905 6.35437 10.6056 7.33316 10.6056 8.36346C10.6056 8.83701 10.5123 9.30593 10.3311 9.74344C10.1499 10.1809 9.88428 10.5785 9.54942 10.9133C9.21457 11.2482 8.81704 11.5138 8.37953 11.695C7.94203 11.8762 7.47311 11.9695 6.99955 11.9695C6.526 11.9695 6.05708 11.8762 5.61957 11.695C5.18207 11.5138 4.78454 11.2482 4.44968 10.9133C4.11483 10.5785 3.84921 10.1809 3.66799 9.74344C3.48677 9.30593 3.39349 8.83701 3.39349 8.36346C3.39349 7.76949 3.61655 7.1817 3.90865 6.818C3.90865 7.15957 4.04433 7.48715 4.28586 7.72867C4.52738 7.9702 4.85496 8.10588 5.19652 8.10588Z",
                            fill: "#FF2D55"
                        })
                    })
                ]
            }),
            !iconOnly && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (loco_score_module_default()).text,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (loco_score_module_default()).title,
                        children: "LocoScore"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (loco_score_module_default()).description,
                        children: getDescriptionFromRating()
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/styleguide/LocoScore/index.ts



/***/ }),

/***/ 52733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* reexport */ VehicleImage; },
  "C": function() { return /* reexport */ VehicleImageWithGallery; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/styleguide/VehicleImage/vehicle-image.module.scss
var vehicle_image_module = __webpack_require__(80001);
var vehicle_image_module_default = /*#__PURE__*/__webpack_require__.n(vehicle_image_module);
// EXTERNAL MODULE: ./lib/utilities/vehicle.js
var vehicle = __webpack_require__(13732);
;// CONCATENATED MODULE: ./components/styleguide/VehicleImage/VehicleImage.tsx




var VehicleImage = function(param) {
    var alt = param.alt, height = param.height, width = param.width, imagePath = param.imagePath, backupImagePath = param.backupImagePath, _priority = param.priority, priority = _priority === void 0 ? false : _priority, _quality = param.quality, quality = _quality === void 0 ? 75 : _quality, _layout = param.layout, layout = _layout === void 0 ? undefined : _layout, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "empty" : _placeholder, blurDataURL = param.blurDataURL, _className = param.className, className = _className === void 0 ? "" : _className, _type = param.type, type = _type === void 0 ? "DEFAULT" : _type, _unoptimized = param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "\n        ".concat(type !== "GALLERY" && type !== "BROWSE" && type !== "HOMEPAGE" && imagePath ? (vehicle_image_module_default())["reverse-image"] : "", " ").concat(!imagePath ? (vehicle_image_module_default())["padded-image"] : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: imagePath ? (0,vehicle/* getGalleryImage */.Dq)(imagePath) : (0,vehicle/* getVehicleHeroImage */.Nk)(backupImagePath),
            alt: alt,
            height: height,
            width: width,
            priority: priority,
            quality: quality,
            layout: layout,
            placeholder: placeholder,
            blurDataURL: blurDataURL,
            className: className,
            unoptimized: unoptimized
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-awesome-reveal/dist/index.js + 1 modules
var dist = __webpack_require__(81277);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
;// CONCATENATED MODULE: ./components/styleguide/VehicleImage/VehicleImageWithGallery.tsx








var VehicleImageWithGallery = function(param) {
    var alt = param.alt, height = param.height, width = param.width, images = param.images, _quality = param.quality, quality = _quality === void 0 ? 75 : _quality, _layout = param.layout, layout = _layout === void 0 ? undefined : _layout, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? undefined : _placeholder, blurDataURL = param.blurDataURL, _className = param.className, className = _className === void 0 ? "" : _className, _unoptimized = param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _type = param.type, type = _type === void 0 ? "DEFAULT" : _type, _showDots = param.showDots, showDots = _showDots === void 0 ? true : _showDots, _alignDots = param.alignDots, alignDots = _alignDots === void 0 ? "center" : _alignDots, onChangeIndex = param.onChangeIndex;
    var ref = (0,react.useState)(0), currentIndex = ref[0], setCurrentIndex = ref[1];
    var ref1 = (0,react.useRef)(null);
    var onChangeCurrentIndex = function(index) {
        if (onChangeIndex) {
            onChangeIndex(index);
        }
        setCurrentIndex(index);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (vehicle_image_module_default()).wrapper,
        "data-type": type,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: ref1,
                className: (vehicle_image_module_default()).carousel,
                onScroll: function(e) {
                    var target = e.target;
                    var calculation = Math.floor(target.scrollLeft / target.children[0].clientWidth);
                    onChangeCurrentIndex(calculation < 0 ? 0 : calculation);
                },
                children: images.filter(function(image) {
                    return image.angleType === "EXTERIOR";
                }).sort(function(a) {
                    return a.angle === "lowaggressive" ? -1 : 1;
                }).map(function(image, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                        triggerOnce: true,
                        duration: 1000,
                        className: (vehicle_image_module_default()).item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            "data-index": index,
                            className: "".concat((vehicle_image_module_default()).content, " ").concat(type !== "GALLERY" && type !== "BROWSE" && type !== "HOMEPAGE" && image.path ? (vehicle_image_module_default())["reverse-image"] : "", " ").concat(type === "SPEC" ? (vehicle_image_module_default())["spec-image"] : ""),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: (0,vehicle/* getGalleryImage */.Dq)(image.path),
                                alt: alt,
                                height: height,
                                width: width,
                                quality: quality,
                                layout: layout,
                                placeholder: placeholder,
                                blurDataURL: blurDataURL,
                                className: className,
                                unoptimized: unoptimized
                            })
                        })
                    }, image.id);
                })
            }),
            showDots && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: (vehicle_image_module_default()).dots,
                "data-alignment": alignDots,
                children: images.filter(function(image) {
                    return image.angleType === "EXTERIOR";
                }).sort(function(a) {
                    return a.angle === "lowaggressive" ? -1 : 1;
                }).map(function(image, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "".concat((vehicle_image_module_default()).dot).concat(currentIndex === index ? " " + (vehicle_image_module_default()).active : "").concat(Math.abs(currentIndex - index) > 2 ? Math.abs(currentIndex - index) >= 4 ? " " + (vehicle_image_module_default())["too-far"] : " " + (vehicle_image_module_default()).far : Math.abs(currentIndex - index) > 1 ? " " + (vehicle_image_module_default()).close : "")
                    }, image.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (vehicle_image_module_default()).arrows,
                "data-navigation-position": currentIndex === 0 ? "start" : currentIndex === images.filter(function(image) {
                    return image.angleType === "EXTERIOR";
                }).sort(function(a) {
                    return a.angle === "lowaggressive" ? -1 : 1;
                }).length - 1 ? "end" : "middle",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        onClick: function() {
                            var ref, ref2, ref3;
                            ref1 === null || ref1 === void 0 ? void 0 : (ref = ref1.current) === null || ref === void 0 ? void 0 : ref.scrollTo({
                                left: ref1.current.scrollLeft - ((ref3 = ref1 === null || ref1 === void 0 ? void 0 : (ref2 = ref1.current) === null || ref2 === void 0 ? void 0 : ref2.children[0]) === null || ref3 === void 0 ? void 0 : ref3.clientWidth),
                                behavior: "smooth"
                            });
                        },
                        icon: "ChevronLeft",
                        size: system/* Size.ExtraSmall */.$u.ExtraSmall,
                        hierarchy: type === "SPEC" ? Button/* ButtonHierarchy.BezeledGray */.B.BezeledGray : Button/* ButtonHierarchy.Filled */.B.Filled,
                        theme: type === "SPEC" ? system/* Theme.light */.Q2.light : system/* Theme.dark */.Q2.dark
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        onClick: function() {
                            var ref, ref2, ref3;
                            ref1 === null || ref1 === void 0 ? void 0 : (ref = ref1.current) === null || ref === void 0 ? void 0 : ref.scrollTo({
                                left: ref1.current.scrollLeft + ((ref3 = ref1 === null || ref1 === void 0 ? void 0 : (ref2 = ref1.current) === null || ref2 === void 0 ? void 0 : ref2.children[0]) === null || ref3 === void 0 ? void 0 : ref3.clientWidth),
                                behavior: "smooth"
                            });
                        },
                        theme: type === "SPEC" ? system/* Theme.light */.Q2.light : system/* Theme.dark */.Q2.dark,
                        icon: "ChevronRight",
                        size: system/* Size.ExtraSmall */.$u.ExtraSmall,
                        hierarchy: type === "SPEC" ? Button/* ButtonHierarchy.BezeledGray */.B.BezeledGray : Button/* ButtonHierarchy.Filled */.B.Filled
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/styleguide/VehicleImage/index.ts




/***/ }),

/***/ 80303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ SearchResultsContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var SearchResultsContainer = function(param) {
    var _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _hasNoResults = param.hasNoResults, hasNoResults = _hasNoResults === void 0 ? false : _hasNoResults, _layout = param.layout, layout = _layout === void 0 ? "grid" : _layout, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: isLoading ? "container--loading" : "container--search-results",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat(layout, " search__results ").concat(hasNoResults ? "search__results--no-results" : ""),
            children: children
        })
    });
};


/***/ }),

/***/ 78525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ WhyLeasePage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_awesome_reveal__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(81277);
/* harmony import */ var _components_atomic_PageMetaData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1429);
/* harmony import */ var _components_styleguide_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96732);
/* harmony import */ var _components_styleguide_Card_Vehicle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48861);
/* harmony import */ var _components_styleguide_ChatWidget__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65299);
/* harmony import */ var _components_styleguide_Header__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(638);
/* harmony import */ var _components_styleguide_Link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63383);
/* harmony import */ var _components_views_SearchResults_views_SearchResultsContainer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80303);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99280);
/* harmony import */ var _lib_routes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7158);
/* harmony import */ var _types_system__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(16693);













function WhyLeasePage() {
    var deal = {
        vehicle: {
            id: 10637,
            manufacturerName: "Audi",
            manufacturer: 1,
            manufacturerWebSite: "http://www.audi.co.uk",
            modelName: "A4 Avant",
            model: 355,
            trimName: "S Line",
            trim: 3354,
            derivativeName: "35 TFSI S Line 5dr S Tronic",
            fuelTypeName: "Petrol",
            transmissionTypeName: "Automatic",
            driveTypeName: "Front Wheel Drive",
            stockStatus: 1,
            seats: 5,
            doors: 5,
            images: {
                profile: "profile/audi_a4_avant_1_new.png",
                side: "side/Audi_A4_Avant_1_new.png",
                gallery: [
                    "Audi/A4 Avant/Audi_A4_Avant_1.jpg",
                    "Audi/A4 Avant/Audi_A4_Avant_2.jpg",
                    "Audi/A4 Avant/Audi_A4_Avant_3.jpg",
                    "Audi/A4 Avant/Audi_A4_Avant_4.jpg",
                    "Audi/A4 Avant/Audi_A4_Avant_5.jpg",
                    "Audi/A4 Avant/Audi_A4_Avant_6.jpg",
                    "Audi/A4 Avant/Audi_A4_Avant_7.jpg", 
                ]
            },
            vehicleType: 1
        },
        vehiclePrice: {
            manufacturerName: "Audi",
            modelName: "A4 Avant",
            derivativeName: "35 TFSI S Line 5dr S Tronic",
            id: 134403080,
            vehicleId: 10637,
            rating: 86,
            initialPaymentInMoney: 0,
            initialPaymentInMonths: 9,
            documentFee: 0,
            leaseType: 2,
            term: 48,
            mileage: 10000,
            monthlyPayment: 245.23,
            monthlyPaymentAverage: null,
            stockStatus: 1
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atomic_PageMetaData__WEBPACK_IMPORTED_MODULE_2__/* .PageMetaData */ .S, {
                title: "Why Lease A Car? - Car Leasing Made Simple at LeaseLoco",
                description: "If you're wondering why you should lease a car, look no further, we'll give you 7 great reasons. Car Leasing Made Simple at LeaseLoco.",
                pageUrl: _lib_routes__WEBPACK_IMPORTED_MODULE_10__/* .ROUTES.whyLeasePage.url */ .Z.whyLeasePage.url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_ChatWidget__WEBPACK_IMPORTED_MODULE_5__/* .ChatWidget */ .A, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Header__WEBPACK_IMPORTED_MODULE_6__/* .Header */ .h, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "white-base-layer",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container container--body container--why-lease",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "col-12 col-lg-10 offset-lg-1 text-left",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_awesome_reveal__WEBPACK_IMPORTED_MODULE_12__/* .Fade */ .pT, {
                                triggerOnce: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "why-lease__container why-lease__container--white pt-0",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                            className: "secondary-header",
                                            children: "Why lease?"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "text-semibold",
                                            children: [
                                                "The #1 reason to choose",
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Link__WEBPACK_IMPORTED_MODULE_7__/* .InternalLink */ .h, {
                                                    href: _lib_routes__WEBPACK_IMPORTED_MODULE_10__/* .ROUTES.homePage.url */ .Z.homePage.url,
                                                    size: _types_system__WEBPACK_IMPORTED_MODULE_11__/* .Size.Large */ .$u.Large,
                                                    hierarchy: _components_styleguide_Button__WEBPACK_IMPORTED_MODULE_3__/* .ButtonHierarchy.Borderless */ .B.Borderless,
                                                    children: "leasing"
                                                }),
                                                " ",
                                                "over buying is COST."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "mb-4",
                                            children: [
                                                "Take this example of this Audi A4 Avant we have a deal",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("sup", {
                                                    children: "*"
                                                }),
                                                " on:"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_views_SearchResults_views_SearchResultsContainer__WEBPACK_IMPORTED_MODULE_8__/* .SearchResultsContainer */ .q, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Card_Vehicle__WEBPACK_IMPORTED_MODULE_4__/* .VehicleCard */ .U, {
                                                deal: deal
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-4",
                                            children: "A few things to note:"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ol", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: "The list price of the car is \xa336,995.00"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: "The trade in price for this car is around \xa313,000."
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: "This all means there is around \xa324,000 of depreciation. And it doesn't even take into account financing costs."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "Most people when they buy a new car take out a PCP loan (Personal Contract Purchase). So let's look at the cost of this for the A4..."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    className: "link",
                                                    href: "https://www.audi.co.uk/finance-and-offers/pcp-deals.html",
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    children: "Audi are offering a PCP deal"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("sup", {
                                                    children: "*"
                                                }),
                                                " on their website for the exact same A4 Avant model also on a 4 year term with 10,000 miles per annum."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "table-container my-4",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "table-responsive",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("table", {
                                                        className: "table table-borderless table-sm",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("caption", {
                                                                children: "PCP figures from Audi"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tbody", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                                                children: "47 monthly payments of"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                                                className: "background-grey border-top-right",
                                                                                children: "\xa3389.00"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                                                children: "Intial payment"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                                                className: "background-grey",
                                                                                children: "\xa35,926.66"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                                                children: "Total over term"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                                                className: "background-grey border-bottom-right",
                                                                                children: "\xa324,209.66"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "table-responsive",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("table", {
                                                        className: "table table-borderless table-sm",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("caption", {
                                                                children: "Lease figures from LeaseLoco"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tbody", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                                                children: "47 monthly payments of"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                                                className: "background-grey border-top-right",
                                                                                children: "\xa3294.28"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                                                children: "Intial payment"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                                                className: "background-grey",
                                                                                children: "\xa32,648.48"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                                                children: "Total over term"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                                                className: "background-grey border-bottom-right",
                                                                                children: "\xa316,479.64"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            children: [
                                                "The lease deal on LeaseLoco would save you",
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "pink",
                                                    children: "\xa37,730.02"
                                                }),
                                                " over the course of the term compared to the PCP deal on offer from Audi. That's almost \xa32,000 per year!!"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "And that Hombre, is the main reason leasing is better than buying!"
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "alternate-base-layer",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container-fluid container--body container--why-lease",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-12 col-lg-5 order-lg-2 text-left",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_awesome_reveal__WEBPACK_IMPORTED_MODULE_12__/* .Fade */ .pT, {
                                    delay: 400,
                                    triggerOnce: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "why-lease__container pt-0",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-large",
                                                children: "ARRIBA!"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: "So any other good reasons?"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: "Of course, Amigos!"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        children: "New cars."
                                                    }),
                                                    " All",
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Link__WEBPACK_IMPORTED_MODULE_7__/* .InternalLink */ .h, {
                                                        className: "link",
                                                        href: _lib_routes__WEBPACK_IMPORTED_MODULE_10__/* .ROUTES.homePage.url */ .Z.homePage.url,
                                                        hierarchy: _components_styleguide_Button__WEBPACK_IMPORTED_MODULE_3__/* .ButtonHierarchy.Borderless */ .B.Borderless,
                                                        size: _types_system__WEBPACK_IMPORTED_MODULE_11__/* .Size.Large */ .$u.Large,
                                                        children: "cars"
                                                    }),
                                                    " ",
                                                    "and",
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Link__WEBPACK_IMPORTED_MODULE_7__/* .InternalLink */ .h, {
                                                        className: "link",
                                                        href: _lib_routes__WEBPACK_IMPORTED_MODULE_10__/* .ROUTES.vanHomePage.url */ .Z.vanHomePage.url,
                                                        hierarchy: _components_styleguide_Button__WEBPACK_IMPORTED_MODULE_3__/* .ButtonHierarchy.Borderless */ .B.Borderless,
                                                        size: _types_system__WEBPACK_IMPORTED_MODULE_11__/* .Size.Large */ .$u.Large,
                                                        children: "vans"
                                                    }),
                                                    " ",
                                                    "leased through LeaseLoco are brand new. Some may be pre-registered but our leasing partner would confirm that when you make an enquiry with them."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        children: "No road tax."
                                                    }),
                                                    " All cars leased through LeaseLoco include road tax in the monthly payment. This can save you hundreds of \xa3\xa3\xa3 over the term."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        children: "Flexibility."
                                                    }),
                                                    " Funders of lease cars are becoming more and more aware for lease contracts to be flexible. This means you can often terminate the lease early without being committed to the remaining lease payments; you will have early termination penalties but these can often be significantly less than the remaining lease payments (around 55% in some cases but this will vary on a case to case basis and you should always contact your funder to clarify the exact figures)."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        children: "Breakdown cover."
                                                    }),
                                                    " More and more manufacturers provide free breakdown cover for the warranty period of the car, meaning even more piece of mind for you."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        children: "Never sell your car again."
                                                    }),
                                                    " You don't own the car so you don't sell it. You simply hand it back. So no hassle and no tyre kickers at the end of your term to worry about."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        children: "No depreciation worries."
                                                    }),
                                                    " Your payments are fixed so even if the government massively increases tax on diesels in the middle of your lease, you don't have to worry about it."
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-12 col-lg-3 offset-lg-2 order-lg-1",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "why-lease__image-container",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        src: "".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_9__/* .constants.imageHost.assets */ ._G.imageHost.assets, "/mascot/full-body-3.png"),
                                        alt: "Luis Loco",
                                        height: "473",
                                        width: "320"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-12 order-3",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "text-small mt-5",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("sup", {
                                            children: "*"
                                        }),
                                        " Both lease and PCP deals were available on 13 February 2020 and are most likely not going to be around while you're reading this but the point still stands."
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 53644:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"score":"loco-score_score___FxZc","ring":"loco-score_ring__zuCKC","container":"loco-score_container__p90CW","text":"loco-score_text__w_aMB","title":"loco-score_title__zoTzI","description":"loco-score_description__MfcQu","phAnimation":"loco-score_phAnimation__ElO02"};

/***/ }),

/***/ 80001:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"reverse-image":"vehicle-image_reverse-image__uOgl_","padded-image":"vehicle-image_padded-image__sESfX","wrapper":"vehicle-image_wrapper__zluzR","arrows":"vehicle-image_arrows__4kG9G","dots":"vehicle-image_dots__RtU0B","dot":"vehicle-image_dot__bxknn","close":"vehicle-image_close__agwhd","far":"vehicle-image_far___i7DM","too-far":"vehicle-image_too-far__Mglyo","active":"vehicle-image_active__a6CKC","carousel":"vehicle-image_carousel__kVC1q","item":"vehicle-image_item__XBP0m","content":"vehicle-image_content__qHmo1","spec-image":"vehicle-image_spec-image__EEsLS","phAnimation":"vehicle-image_phAnimation__X2gd8"};

/***/ }),

/***/ 26525:
/***/ (function(module) {

module.exports = function(md, options) {
  options = options || {};
  options.listUnicodeChar = options.hasOwnProperty('listUnicodeChar') ? options.listUnicodeChar : false;
  options.stripListLeaders = options.hasOwnProperty('stripListLeaders') ? options.stripListLeaders : true;
  options.gfm = options.hasOwnProperty('gfm') ? options.gfm : true;
  options.useImgAltText = options.hasOwnProperty('useImgAltText') ? options.useImgAltText : true;

  var output = md || '';

  // Remove horizontal rules (stripListHeaders conflict with this rule, which is why it has been moved to the top)
  output = output.replace(/^(-\s*?|\*\s*?|_\s*?){3,}\s*$/gm, '');

  try {
    if (options.stripListLeaders) {
      if (options.listUnicodeChar)
        output = output.replace(/^([\s\t]*)([\*\-\+]|\d+\.)\s+/gm, options.listUnicodeChar + ' $1');
      else
        output = output.replace(/^([\s\t]*)([\*\-\+]|\d+\.)\s+/gm, '$1');
    }
    if (options.gfm) {
      output = output
        // Header
        .replace(/\n={2,}/g, '\n')
        // Fenced codeblocks
        .replace(/~{3}.*\n/g, '')
        // Strikethrough
        .replace(/~~/g, '')
        // Fenced codeblocks
        .replace(/`{3}.*\n/g, '');
    }
    output = output
      // Remove HTML tags
      .replace(/<[^>]*>/g, '')
      // Remove setext-style headers
      .replace(/^[=\-]{2,}\s*$/g, '')
      // Remove footnotes?
      .replace(/\[\^.+?\](\: .*?$)?/g, '')
      .replace(/\s{0,2}\[.*?\]: .*?$/g, '')
      // Remove images
      .replace(/\!\[(.*?)\][\[\(].*?[\]\)]/g, options.useImgAltText ? '$1' : '')
      // Remove inline links
      .replace(/\[(.*?)\][\[\(].*?[\]\)]/g, '$1')
      // Remove blockquotes
      .replace(/^\s{0,3}>\s?/g, '')
      // Remove reference-style links?
      .replace(/^\s{1,2}\[(.*?)\]: (\S+)( ".*?")?\s*$/g, '')
      // Remove atx-style headers
      .replace(/^(\n)?\s{0,}#{1,6}\s+| {0,}(\n)?\s{0,}#{0,} {0,}(\n)?\s{0,}$/gm, '$1$2$3')
      // Remove emphasis (repeat the line to remove double emphasis)
      .replace(/([\*_]{1,3})(\S.*?\S{0,1})\1/g, '$2')
      .replace(/([\*_]{1,3})(\S.*?\S{0,1})\1/g, '$2')
      // Remove code blocks
      .replace(/(`{3,})(.*?)\1/gm, '$2')
      // Remove inline code
      .replace(/`(.+?)`/g, '$1')
      // Replace two or more newlines with exactly two? Not entirely sure this belongs here...
      .replace(/\n{2,}/g, '\n\n');
  } catch(e) {
    console.error(e);
    return md;
  }
  return output;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1852,5675,1967,264,638,1429,3052,9774,2888,179], function() { return __webpack_exec__(39504); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);